/**
 * Get the season based on the current day
 * @param {number} day - The current game day
 * @returns {string} The current season (Spring, Summer, Autumn, or Winter)
 */
export const getSeason = (day) => {
  const cycle = Math.floor((day - 1) / 5) % 4;
  return ['Spring', 'Summer', 'Autumn', 'Winter'][cycle];
};

/**
 * Get the season ID for ambience/sound effects
 * @param {number} day - The current game day
 * @returns {string} The season ID (spring, summer, fall, or winter)
 */
export const getSeasonId = (day) => {
  const cycle = Math.floor((day - 1) / 5) % 4;
  return ['spring', 'summer', 'fall', 'winter'][cycle];
};

/**
 * Get the current year based on the current day
 * @param {number} day - The current game day
 * @returns {number} The current year (starting at 1)
 */
export const getYear = (day) => Math.floor((day - 1) / 20) + 1;
